import React from 'react';

export const IconPersonAdd = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.85001 6.59999V5.54999H7.80001V4.64999H8.85001V3.59999H9.75001V4.64999H10.8V5.54999H9.75001V6.59999H8.85001ZM4.80001 5.99999C4.30001 5.99999 3.87501 5.82499 3.52501 5.47499C3.17501 5.12499 3.00001 4.69999 3.00001 4.19999C3.00001 3.69999 3.17501 3.27499 3.52501 2.92499C3.87501 2.57499 4.30001 2.39999 4.80001 2.39999C5.30001 2.39999 5.72501 2.57499 6.07501 2.92499C6.42501 3.27499 6.60001 3.69999 6.60001 4.19999C6.60001 4.69999 6.42501 5.12499 6.07501 5.47499C5.72501 5.82499 5.30001 5.99999 4.80001 5.99999ZM1.20001 9.59999V8.44999C1.20001 8.23516 1.2521 8.0377 1.35626 7.85762C1.46043 7.67754 1.60418 7.53333 1.78751 7.42499C2.24585 7.15833 2.72918 6.95416 3.23751 6.81249C3.74585 6.67083 4.26668 6.59999 4.80001 6.59999C5.33335 6.59999 5.85418 6.67083 6.36251 6.81249C6.87085 6.95416 7.35418 7.15833 7.81251 7.42499C7.99585 7.53333 8.1396 7.67754 8.24376 7.85762C8.34793 8.0377 8.40001 8.23516 8.40001 8.44999V9.59999H1.20001Z"
        fill="currentColor"
      />
    </svg>
  );
};
